// extracted by mini-css-extract-plugin
export var chips = "QuickStakeChips-module--chips--2c19b";